import {useLayoutEffect, useState} from "react";
import {_isInViewport} from "../helpers/HelperFunc";

export function isInViewPortHook(elementId, partially = false) {

	const [isInViewPort, setIsInViewPort] = useState(false);

	const updateIsInViewPort = () => {
		const element = document.getElementById(elementId);
		const isInViewPortTMP = _isInViewport(element, partially)

		if (isInViewPortTMP !== isInViewPort) {
			setIsInViewPort(isInViewPortTMP);
		}
	}

	useLayoutEffect(() => {
		updateIsInViewPort();
		window.addEventListener("scroll",
			() => updateIsInViewPort());
		return () => {
			window.removeEventListener("scroll",
				() => updateIsInViewPort());
		};
	}, [isInViewPort]);

	return isInViewPort;
}
